import { Studio } from "@/api/Studio";
import { DynamicContent, PageSize } from "pdfmake/interfaces";

const sammelanmeldungPdfHeader = (studio: Studio): DynamicContent =>
  function(currentPage: number, pageCount: number, pageSize: PageSize) {
    return [
      {
        layout: "solidHorizontalLines",
        margin: [74, 37, 29, 3],
        table: {
          widths: [400, "*"],
          headerRows: 0,
          keepWithHeaderRows: 0,
          body: [
            [
              {
                text: `Finanzamt ${
                  studio.finanzamt || ""
                }\nSteuernummer: ${
                  studio.steuernummer || ""
                }`,
                margin: [0, 0, 0, 3],
              },
              {
                text: "Blatt " + currentPage + "/" + pageCount,
                alignment: "right",
                margin: [0, 0, 37, 0],
              },
            ],
            [{ text: "", colSpan: 2 }, {}],
          ],
        },
      },
    ];
  };

export { sammelanmeldungPdfHeader };
